<template>
  <div class="px-page mb-8 lg:flex lg:items-start lg:justify-between">
    <div class="min-w-0 flex-1">
      <h2 class="text-xl font-semibold leading-tight">Order | {{ order.order_number }}</h2>
      <small class="mt-1">{{ order.ordered_on }}</small>
      <div class="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-4">
        <QaStatusBadge :qa-status="order.qa_status" />
      </div>
    </div>
    <div class="mt-5 flex lg:ml-4 lg:mt-0">
      <!-- Dropdown -->
      <Menu as="div" class="relative ml-3">
        <MenuButton class="btn btn-primary">
          Actions
          <ChevronDownIcon class="-mr-1 ml-1.5 h-5 w-5 text-white" aria-hidden="true" />
        </MenuButton>

        <transition enter-active-class="transition ease-out duration-200" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
          <MenuItems class="absolute right-0 z-10 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
            <div class="py-1">
              <MenuItem v-slot="{ active }">
                <a href="#" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                  <ArrowTopRightOnSquareIcon class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                  Shopify
                </a>
              </MenuItem>
              <MenuItem v-slot="{ active }">
                <a href="#" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                  <ArrowTopRightOnSquareIcon class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                  NetSuite
                </a>
              </MenuItem>
              <MenuItem v-slot="{ active }">
                <a href="#" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                  <ArrowTopRightOnSquareIcon class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                  ShipStation
                </a>
              </MenuItem>
            </div>
            <div class="py-1">
              <MenuItem v-slot="{ active }">
                <a href="#" :class="[active ? 'bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm']">
                  <ArrowPathIcon class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                  Refresh
                </a>
              </MenuItem>
            </div>
          </MenuItems>
        </transition>
      </Menu>
    </div>
  </div>

  <TabGroup>
    <div class="px-page">
      <TabList class="flex space-x-6 xl:space-x-8">
        <Tab v-slot="{ selected }" as="template">
          <span :class="[selected ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:border-primary hover:text-primary']" class="cursor-pointer whitespace-nowrap border-b-2 px-1 py-4 font-medium focus:outline-none"> Notes </span>
        </Tab>
        <Tab v-if="order.custom_orders" v-slot="{ selected }" as="template">
          <span :class="[selected ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:border-primary hover:text-primary']" class="cursor-pointer whitespace-nowrap border-b-2 px-1 py-4 font-medium focus:outline-none"> Customs </span>
        </Tab>
      </TabList>
    </div>
    <TabPanels class="card">
      <TabPanel>
        <div class="card-body">
          <form class="relative" @submit="storeNotes">
            <div class="overflow-hidden rounded-lg shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-primary">
              <label for="comment" class="sr-only">Add your notes</label>
              <textarea v-model="form.notes" rows="6" class="block w-full resize-none border-0 bg-transparent py-1.5 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6" placeholder="Add your comment..." />

              <!-- Spacer element to match the height of the toolbar -->
              <div class="py-2" aria-hidden="true">
                <!-- Matches height of button in toolbar (1px border + 36px content height) -->
                <div class="py-px">
                  <div class="h-9" />
                </div>
              </div>
            </div>

            <div class="absolute inset-x-0 bottom-0 flex justify-between py-2 pl-3 pr-2">
              <div class="flex-shrink-0">
                <button type="submit" class="btn btn-primary">Save</button>
              </div>
            </div>
          </form>
        </div>
      </TabPanel>
      <TabPanel v-if="order.custom_orders">
        <Customs :orders="order.custom_orders" />
      </TabPanel>
    </TabPanels>
  </TabGroup>
</template>

<script setup>
import { Menu, MenuButton, MenuItem, MenuItems, Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/vue";
import { ArrowPathIcon, ArrowTopRightOnSquareIcon, ChevronDownIcon } from "@heroicons/vue/20/solid";
import { useForm } from "@inertiajs/vue3";

import Customs from "./Customs";
import QaStatusBadge from "../../components/orders/QaStatusBadge";

const { order } = defineProps({
  order: Object,
});

const form = useForm({
  notes: order.notes,
});

const storeNotes = () => {
  form.post(route("orders.notes.store", order.order_number), form);
};
</script>
